import {
	Button,
	Flex,
	Text,
	Image,
	Modal,
	ModalBody,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	useDisclosure,
	FormControl,
	FormLabel,
	Input,
	Select,
	useToast,
	FormErrorMessage,
} from '@chakra-ui/react'
import { countries } from '../../../Data/Countries'
import {
	GoogleReCaptchaProvider,
	GoogleReCaptcha,
} from 'react-google-recaptcha-v3'

import { useForm, Controller } from 'react-hook-form'
import RequestIcons from '../../../Assets/RequestIcons.svg'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './../extra-styles.css'
import { useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const RequestAQuote = () => {
	const toast = useToast({})
	const handleVerify = (token: string) => {
		console.log(token)
	}
	const [dateTime, setDateTime] = useState<Date>()

	const {
		register,
		handleSubmit,
		control,
		formState: { errors, isValid },
	} = useForm({ mode: 'onChange' })
	const onSubmit = (data: any) => {
		console.log(data)
		console.log(dateTime)
		console.log(errors)
		toast({
			status: 'success',
			description:
				'Thank you for your request. We will get back to you shortly.',
			position: 'top',
		})
		onClose()
	}
	const { isOpen, onOpen, onClose } = useDisclosure()
	console.log(errors)
	console.log(isValid)
	return (
		// <GoogleReCaptchaProvider reCaptchaKey="6Le6lDsjAAAAAC3pPU0cANt-3Ng-mNw9HvHToo4z">
		<Flex
			onClick={onOpen}
			flexDirection={'column'}
			align="center"
			justify="center"
			// mt={{
			// 	base: 0,
			// 	md: '2.25rem',
			// }}
			minW={{
				base: '75%',
				md: 'unset',
			}}
			rowGap={'2.5rem'}
		>
			<Button colorScheme="red" height="10.5rem" width="14rem" p="2rem">
				<Flex flexDir={'column'} gap="1rem">
					<Image mt="0.5rem" src={RequestIcons} height="3rem" />
					<Text
						fontWeight="800"
						whiteSpace={'normal'}
						fontSize={'xl'}
						color="white"
					>
						REQUEST A QUOTE
					</Text>
				</Flex>
			</Button>
			{/* <Image
				display={{
					base: 'none',
					md: 'initial',
				}}
				src={SpecPdfIcons}
				height="5rem"
			/> */}
			<Modal size={['sm', null, '3xl']} isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius="lg">
					<ModalHeader
						borderTopRadius={'lg'}
						textAlign={'center'}
						color="white"
						fontWeight={'bold'}
						fontSize={'1.75rem'}
						bg="orange.500"
					>
						Request a Quote
					</ModalHeader>
					<ModalBody as="form">
						<Flex mt="1rem" gap="1rem" flexWrap={'wrap'} flexDir={'column'}>
							<Flex gap={'1rem'} flexDir={{ base: 'column', md: 'row' }}>
								{/* {!isMobile && (
									<FormControl>
										<FormLabel> Subject</FormLabel>
										<Input
											type="text"
											defaultValue={'Request a Quote'}
											placeholder="Market Segment"
											{...register('Subject', { maxLength: 50 })}
										/>
									</FormControl>
								)} */}
								<FormControl>
									<FormLabel> Company</FormLabel>
									<Input
										type="text"
										placeholder="Company Name"
										{...register('Company Name', { maxLength: 50 })}
									/>
								</FormControl>
							</Flex>
							<Flex gap={'1rem'}>
								<FormControl isRequired>
									<FormLabel> First Name</FormLabel>
									<Input
										type="text"
										placeholder="First name"
										{...register('First name', {
											maxLength: 40,
											required: true,
											minLength: {
												value: 2,
												message: 'First name is too short',
											},
										})}
									/>
									<FormErrorMessage>
										<> {errors['First name']?.message} </>
									</FormErrorMessage>
								</FormControl>
								<FormControl isRequired>
									<FormLabel> Last Name</FormLabel>
									<Input
										type="text"
										placeholder="Last name"
										{...register('Last name', {
											maxLength: 100,
											required: true,
											minLength: {
												value: 2,
												message: 'Your last name is too short',
											},
										})}
									/>
									<FormErrorMessage>
										<> {errors['Last name']?.message} </>
									</FormErrorMessage>
								</FormControl>
							</Flex>
							<Flex flexWrap={'wrap'} gap={'1rem'}>
								<FormControl isRequired isInvalid={!!errors?.phone?.message}>
									<FormLabel> Phone</FormLabel>
									<Controller
										name="phone"
										control={control}
										rules={{
											required: true,
											minLength: {
												value: 10,
												message: 'Your Phone Number is too short',
											},
										}}
										render={({ field: { ref, ...field } }) => (
											<PhoneInput
												autoFormat
												enableLongNumbers
												alwaysDefaultMask
												defaultMask="(...) ...-.... ext ....."
												inputProps={{
													id: 'phone',
													ref,
													required: true,
												}}
												inputClass="phone-input width-full"
												country={'ca'}
												{...field}
											/>
										)}
									/>
									<FormErrorMessage>
										<> {errors?.phone?.message} </>
									</FormErrorMessage>
									{/* <Input
											width={'10%'}
											type={'number'}
											inputMode="numeric"
											{...register('extension')}
										/> */}
								</FormControl>

								<FormControl isRequired>
									<FormLabel> Email</FormLabel>
									<Input
										type="email"
										placeholder="Email"
										{...register('Email', {
											required: true,
										})}
									/>
								</FormControl>
							</Flex>
							<Flex
								flexWrap={'wrap'}
								justifyContent={'space-between'}
								gap="1rem"
							>
								<FormControl
									minWidth={{ md: '21rem' }}
									width={{ base: '100%', md: '49%' }}
								>
									<FormLabel> Best Time to Call</FormLabel>

									<DatePicker
										popperPlacement="top-start"
										placeholderText="Select a date and time"
										className="phone-input width-full"
										showTwoColumnMonthYearPicker
										showTimeSelect
										minDate={new Date()}
										selected={dateTime}
										dateFormat="MMMM d, yyyy h:mm aa"
										onChange={(date) => setDateTime(date || new Date())}
									/>
								</FormControl>

								<FormControl width={{ base: '100%', md: '48.5%' }}>
									<FormLabel>Country</FormLabel>
									<Select defaultValue={'CA'} {...register('country')}>
										{countries.map((country) => (
											<option key={country.name} value={country.code}>
												{country.name}
											</option>
										))}
									</Select>
								</FormControl>
							</Flex>

							<Button
								disabled={!isValid}
								mt="1rem"
								variant="solid"
								rounded={'full'}
								colorScheme={'orange'}
								width="75%"
								alignSelf={'center'}
								onClick={handleSubmit(onSubmit)}
							>
								SUBMIT
							</Button>
						</Flex>
					</ModalBody>
				</ModalContent>
			</Modal>
		</Flex>
		// 	<GoogleReCaptcha onVerify={handleVerify} />
		// </GoogleReCaptchaProvider>
	)
}
export default RequestAQuote
